import { render, staticRenderFns } from "./addUser.vue?vue&type=template&id=71607df8&"
import script from "./addUser.vue?vue&type=script&lang=js&"
export * from "./addUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports